import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NewsletterSection from './components/NewsletterSection';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Route-level code splitting — each page ships as its own chunk so the initial
// bundle stays small (Home in particular is large). Loaded on demand.
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Contact = lazy(() => import('./pages/Contact'));
const Services = lazy(() => import('./pages/Services'));
const Hub = lazy(() => import('./pages/Hub'));
const ContentPage = lazy(() => import('./pages/ContentPage'));
const Careers = lazy(() => import('./pages/Careers'));
const CareerDetail = lazy(() => import('./pages/CareerDetail'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const DigitalTwin = lazy(() => import('./pages/DigitalTwin'));
const AIAgents = lazy(() => import('./pages/AIAgents'));
const Simulation = lazy(() => import('./pages/Simulation'));
const Drone = lazy(() => import('./pages/Drone'));
const XRSolutions = lazy(() => import('./pages/XRSolutions'));
const SaaS = lazy(() => import('./pages/SaaS'));
const Awards = lazy(() => import('./pages/Awards'));

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/services" element={<Services />} />
            <Route path="/Portfolio" element={<Portfolio />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Hub" element={<Hub />} />
            <Route path="/hub" element={<Hub />} />
            <Route path="/terms" element={<ContentPage slug="terms" />} />
            <Route path="/privacy" element={<ContentPage slug="privacy" />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:id" element={<CareerDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/digital-twin" element={<DigitalTwin />} />
            <Route path="/ai-agents" element={<AIAgents />} />
            <Route path="/simulation" element={<Simulation />} />
            <Route path="/drone" element={<Drone />} />
            <Route path="/xrsolutions" element={<XRSolutions />} />
            <Route path="/saas" element={<SaaS />} />
          </Routes>
        </Suspense>
      </main>
      <NewsletterSection />
      <Footer />
    </>
  );
}
